// @ts-nocheck
import React, { ReactNode, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from './styles'

interface CustomButtonProps {
  color?: string
  background?: string
  fontSize?: string
  fontWeight?: string
  width?: string
  maxWidth?: string
  minWidth?: string
  height?: string
  gap?: string
  hover?: string
  border?: string
  padding?: string
  children?: ReactNode
  disabled?: boolean
  borderRadius?: string
  onClick?: () => void
}

function CustomButton({
  color,
  width,
  maxWidth,
  minWidth,
  height,
  children,
  background,
  fontSize,
  fontWeight,
  gap,
  border,
  hover,
  padding,
  borderRadius,
  onClick,
  disabled,
}: CustomButtonProps) {
  const [isHovered, setIsHovered] = useState(false)
  const buttonStyle = {
    backgroundColor: isHovered ? hover : background,
    color: color,
    fontSize: fontSize,
    fontWeight: fontWeight,
    width: width,
    maxWidth: maxWidth,
    minWidth: minWidth,
    height: height,
    gap: gap,
    border: border,
    padding: padding,
    borderRadius: borderRadius,
  }

  return (
    <Button
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}

CustomButton.propTypes = {
  background: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  fontSize: PropTypes.string.isRequired,
  fontWeight: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  gap: PropTypes.string.isRequired,
  hover: PropTypes.string.isRequired,
  maxWidth: PropTypes.string.isRequired,
  border: PropTypes.string.isRequired,
  padding: PropTypes.string.isRequired,
  borderRadius: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default CustomButton
